import React, { SVGAttributes } from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconLockBadge: React.FC<SVGAttributes<SVGElement>> = ({ ...props }) => {
  const fillColor = props.fill || Styles.color.white;
  return (
    <svg width="13" height="15" viewBox="0 0 13 15" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93482 1.73027C3.67351 0.677791 4.86069 0 6.5 0C8.13931 0 9.32649 0.677791 10.0652 1.73027C10.7669 2.73008 11 3.97262 11 5.06112V7H9V5.06112C9 4.21414 8.81199 3.42613 8.42815 2.87924C8.08128 2.38503 7.51847 2 6.5 2C5.48153 2 4.91872 2.38503 4.57185 2.87924C4.18801 3.42613 4 4.21414 4 5.06112V7H2V5.06112C2 3.97262 2.2331 2.73008 2.93482 1.73027Z"
        fill={fillColor}
      />
      <path
        d="M0 7.5C0 6.67157 0.671573 6 1.5 6H11.5C12.3284 6 13 6.67157 13 7.5V13.5C13 14.3284 12.3284 15 11.5 15H1.5C0.671573 15 0 14.3284 0 13.5V7.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default IconLockBadge;
